/**
 *
 * @param str - The string to process
 * @returns {string} - The processed string with special characters stripped
 * @description Strips special characters, emojis, diacritics, and converts to lowercase
 * this can be useful for more intuitive search and sort comparisons
 */
export const stripSpecialChars = (str: string) =>
  str
    .normalize('NFD') // normalize to decompose characters
    .replace(/[\p{Emoji_Presentation}\p{Punctuation}\p{Symbol}]/gu, '') // remove emojis, punctuation, and symbols
    .replace(/\p{Diacritic}/gu, '') // remove diacritics
    .toLowerCase()
